/**
 * Lädt eine Datei herunter. HINWEIS: nur nutzen falls GET nicht möglich, weil es durch Adblock etc. geblockt werden kann
 *
 * @param blob Die Datei
 * @param filename Der Dateiname
 */

export const downloadFile = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
